<script setup lang="ts">
import { useApiAuctionDetail, useApiTrackSaleView } from '~/apiClient';

definePageMeta({
    key: route => `auction-detail-static-${route.params.slug}`, // Prevent full page re-rendering on locale change
});

// COMPOSABLES
const route = useRoute();
const { id } = useSdpParams();
const { trackViewSale } = useTracking();
const { locale } = useTypedI18n();
const { mutate: trackSaleView } = useApiTrackSaleView();

// DATA
const { data: sale, error, isError, suspense, refetch } = useApiAuctionDetail(id);

// Perform await only if the id is correct resolved to the path
!!id.value && (await suspense());

useSdpParamsChecker(sale, error, isError);

// LIFECYCLE
onMounted(() => {
    if (sale.value) {
        trackViewSale(sale.value);
        trackSaleView({
            data: {
                sales: [{ auctionId: sale.value.id }],
                language: localeToLanguage(locale.value),
                urlPath: route.fullPath,
            },
        });
    }
});
</script>
<template>
    <Sdp v-if="sale" :sale="sale" @refetch="refetch" />
</template>
